import app from './app';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [app]
};

export default menuItems;
